export function is4xxError(status: number | undefined): boolean {
  return !!status && status >= 400 && status < 500
}

export function is5xxError(status: number | undefined): boolean {
  return !!status && status >= 500 && status < 600
}
